import reducer from "./reducers";

export { actions as currentTimerActions } from "./slices";

const currentTimerReducer = reducer;
export default currentTimerReducer;
